import { SET_COMPONENT_HEADER, SET_ONBASE_STATUS } from "./actions"

interface INavigationState {
    header:string;
    onBaseIsUp: boolean;
}

const initialNavState = {
    header:"Dashboard",
    onBaseIsUp: true
};

export default (state:INavigationState=initialNavState, action:any) => {
    let _state = {...state };
    switch (action.type) {
        case SET_COMPONENT_HEADER:
            _state.header = action.value
            return _state;
        case SET_ONBASE_STATUS:
            _state.onBaseIsUp = action.value
            return _state;
        default:
            return _state;

    }
}
